import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  TRESPONSE_BusinessContextData,
  TREQUEST_BusinessContextRequestDTO,
  TRESPONSE_AppSaveEvents,
  TREQUEST_AppEventsRequestDTO,
  TREQUEST_RestoreRequest,
  TRESPONSE_AppStateResponse,
  TREQUEST_ToBeRectifiedListing,
  TRESPONSE_ToBeRectifiedListing,
  TREQUEST_RestoreToBeRectifiedCounts,
  TRESPONSE_RestoreToBeRectifiedCounts,
  TREQUEST_masterdataLists,
  TRESPONSE_masterdataLists,
  TREQUEST_silhouetteKeys,
  TRESPONSE_silhouetteKeys,
  TREQUEST_ServerDefectives,
  TRESPONSE_ServerDefectives,
  TREQUEST_UndoValidation,
  TRESPONSE_UndoValidation,
  TRESPONSE_BackendToBeRectifiedListing,
  TREQUEST_BACK_UP,
  TRESPONSE_BACK_UP,
  TREQUEST_RestoreRequestForBackedUpBctx,
  TRESPONSE_AppStateResponseForBackedUpBctx,
  TREQUEST_correctiveReasons,
  TRESPONSE_correctiveReasons,
  TRESPONSE_UPLOAD_PHOTOS,
  TREQUEST_GET_IMAGE_URLS_BY_IDS,
  TRESPONSE_GET_IMAGE_URLS_BY_IDS,
  TBCTXKeysWithoutSize,
  TREQUEST_RoamingQcTransactions,
  TRESPONSE_RoamingQcTransactions,
  TREQUEST_GET_PER_PIECE_TAG_DETAILS,
  TRESPONSE_GET_PER_PIECE_TAG_DETAILS,
  TREQUEST_GET_PER_PIECE_LINE_IN_TRANSACTIONS,
  TRESPONSE_GET_PER_PIECE_LINE_IN_TRANSACTIONS,
  TREQUEST_masterdataListsV2,
  TRESPONSE_masterdataListsV2,
  TREQUEST_GetBulkSilhouetteOperations,
  TRESPONSE_GetBulkSilhouetteOperations,
  TREQUEST_GetIncompleteBundles,
  TRESPONSE_GetIncompleteBundles,
  TREQUEST_UpdateIncompleteBundles,
  TRESPONSE_UpdateIncompleteBundles,
  TREQUEST_DevicePendingEventsSyncStatusBeforeLogoutAck,
  TRESPONSE_DevicePendingEventsSyncStatusBeforeLogoutAck,
  TREQUEST_GET_PER_PIECE_TAG_HISTORY,
  TRESPONSE_GET_PER_PIECE_TAG_HISTORY,
  TREQUEST_GET_BUNDLE_TAG_HISTORY,
  TRESPONSE_GET_BUNDLE_TAG_HISTORY,
  TREQUEST_GET_CUTBANK_SUBJECTS,
  TRESPONSE_GET_CUTBANK_SUBJECTS,
  TREQUEST_GET_CUT_TAG,
  TRESPONSE_GET_CUT_TAG,
  TREQUEST_CUTBANK_IN_TRANSACTION_LOG,
  TRESPONSE_CUTBANK_IN_TRANSACTION_LOG,
  TREQUEST_CUTBANK_IN_ACTIVITY_LOG,
  TRESPONSE_CUTBANK_IN_ACTIVITY_LOG,
  TRESPONSE_UNDO_TAG_VALIDATION,
  TREQUEST_DELETE_TRANSACTION_LOG,
  TRESPONSE_DELETE_TRANSACTION_LOG,
  TREQUEST_BULK_SAVE_CUTBANK_IN,
  TRESPONSE_BULK_SAVE_CUTBANK_IN,
  TREQUEST_CUTBANK_OUT_TRANSACTION_LOG,
  TRESPONSE_CUTBANK_OUT_TRANSACTION_LOG,
  TREQUEST_UNDO_TAG_VALIDATION_CUTBANK_IN,
  TREQUEST_UNDO_TAG_VALIDATION_CUTBANK_OUT,
  TREQUEST_CUTBANK_OUT_ACTIVITY_LOG,
  TRESPONSE_CUTBANK_OUT_ACTIVITY_LOG,
  TREQUEST_BULK_SAVE_CUTBANK_OUT,
  TREQUEST_TAG_VALIDATION_CUTBANK_IN,
  TREQUEST_TAG_VALIDATION_CUTBANK_OUT,
  TREQUEST_UNDO_TRANSACTION_LINE_IN_EVENT_GENERATE,
  TRESPONSE_UNDO_TRANSACTION_LINE_IN_EVENT_GENERATE,
  TREQUEST_UNDO_TAG_VALIDATION_WITH_BCTX,
  TRESPONSE_UNDO_TAG_VALIDATION_WITH_BCTX,
  TREQUEST_BUNDLE_TAG_DETAILS,
  TRESPONSE_BUNDLE_TAG_DETAILS,
  TREQUEST_GET_COMPONENT_BUNDLE_TAG,
  TRESPONSE_GET_COMPONENT_BUNDLE_TAG,
  TREQUEST_COMPONENT_TAG_VALDATION_CUTBANK_IN,
  TREQUEST_BULK_EDIT_COMPONENT_TAG_QTY,
  TRESPONSE_BULK_EDIT_COMPONENT_TAG_QTY,
  TRESPONSE_BULK_SAVE_COMPONENT_TAG_CUTBANK_IN,
  TREQUEST_COMPONENT_TAG_VALDATION_CUTBANK_OUT,
  TRESPONSE_COMPONENT_TAG_VALIDATION_CUTBANK_IN,
  TRESPONSE_COMPONENT_TAG_VALIDATION_CUTBANK_OUT,
  TRESPONSE_TAG_VALIDATION_CUTBANK_OUT,
  TRESPONSE_TAG_VALIDATION_CUTBANK_IN,
  TREQUEST_LINE_IN_STORE_TAG_STATUS_CUTBANK_OUT,
  TRESPONSE_LINE_IN_STORE_TAG_STATUS_CUTBANK_OUT,
  TREQUEST_VALIDATE_AND_UPDATED_RFID_TAGS_INFO,
  TRESPONSE_VALIDATE_AND_UPDATED_RFID_TAGS_INFO,
  TREQUEST_RFID_TAG_VALIDATION,
  TREQUEST_GET_RFID_TAG_DETAILS,
  TRESPONSE_GET_RFID_TAG_DETAILS,
  TREQUEST_BctxGroupedDetails,
  TRESPONSE_TREQUEST_BctxGroupedDetails,
  TRESPONSE_NewBctxSizeList,
  TREQUEST_GET_COMPONENT_TAG_BY_RFID,
  TRESPONSE_GET_COMPONENT_TAG_BY_RFID,
  TBulkComponentTagWipInfoFromRfidRequest,
  TBulkComponentTagWipInfoFromRfidResponse,
  TREQUEST_TagInfoByRfidTag,
  TRESPONSE_TagInfoByRfidTag,
  TREQUEST_FETCH_PRODUCTION_REASON_LIST,
  TRESPONSE_FETCH_PRODUCTION_REASON_LIST,
  TREQUEST_GET_SESSION_BLOCKS_WITH_REASONS,
  TRESPONSE_GET_SESSION_BLOCKS_WITH_REASONS,
  TREQUEST_SAVE_SESSION_BLOCK_REASONS,
  TRESPONSE_SAVE_SESSION_BLOCK_REASONS,
} from '@monorepo/types';
import { Capacitor } from '@capacitor/core';
import { InputAppEnvService } from './input-app-env.service';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { map, take, timeout } from 'rxjs/operators';
import { CapacitorHttpService } from '../capacitor/capacitor-http.service';
import { Observable } from 'rxjs';
import { MasterdataUtil } from '@monorepo/utils';

@Injectable({
  providedIn: 'root',
})
export class InputAppDataService {
  #capacitor = Capacitor.isNativePlatform();
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    public http: HttpClient,
    public inputAppEnvService: InputAppEnvService,
    private capacitorHttpService: CapacitorHttpService,
  ) {}

  getBusninessContextData(bctxRequestPayload: TREQUEST_BusinessContextRequestDTO) {
    const url = this.inputAppEnvService.getEnvVar('GET_BCTX');
    return this.http.post<TRESPONSE_BusinessContextData>(url, bctxRequestPayload);
  }

  saveEvent(payload: TREQUEST_AppEventsRequestDTO) {
    const url = this.inputAppEnvService.getEnvVar('SAVE_EVENT');
    return this.capacitorHttpService.post<TRESPONSE_AppSaveEvents>(url, payload);
  }

  restoreAppStore(payload: TREQUEST_RestoreRequest) {
    const url = this.inputAppEnvService.getEnvVar('RESTORE_APP_STATE');
    return this.http.post<TRESPONSE_AppStateResponse>(url, payload).pipe(timeout(30000));
  }

  restoreAppStoreForBackedUpBctx(payload: TREQUEST_RestoreRequestForBackedUpBctx) {
    const url = this.inputAppEnvService.getEnvVar('RESTORE_APP_STATE_FOR_BACKED_UP_BCTX');
    return this.http.post<TRESPONSE_AppStateResponseForBackedUpBctx>(url, payload).pipe(timeout(30000));
  }

  getToBeRectifiedData(
    toBeRectifiedRequestPayload: TREQUEST_ToBeRectifiedListing,
  ): Observable<TRESPONSE_ToBeRectifiedListing> {
    const url = this.inputAppEnvService.getEnvVar('TO_BE_RECTIFIED');
    return this.http.post<TRESPONSE_BackendToBeRectifiedListing>(url, toBeRectifiedRequestPayload).pipe(
      take(1),
      map((res) => {
        return {
          ...res,
          records: res.records.map((record) => {
            return {
              ...record,
              datetime: new Date(record.datetime).getTime(),
              bctx: Object.entries(record.bctx).map(([key, value]) => {
                return {
                  k: key as TBCTXKeysWithoutSize,
                  v: value,
                };
              }),
            };
          }),
        };
      }),
    );
  }

  restoreToBeRectifiedCounts(restoreToBeRectifiedCounts: TREQUEST_RestoreToBeRectifiedCounts) {
    const url = this.inputAppEnvService.getEnvVar('RESTORE_TO_BE_RECTIFIED_COUNTS');
    return this.http.post<TRESPONSE_RestoreToBeRectifiedCounts>(url, restoreToBeRectifiedCounts);
  }

  getAllMasterdataLists(request: TREQUEST_masterdataLists) {
    const url = this.inputAppEnvService.getEnvVar('ALL_MASTERDATA_LISTS');
    return this.http.post<TRESPONSE_masterdataLists>(url, request);
  }

  getAllMasterdataListsV2(request: TREQUEST_masterdataListsV2) {
    const url = this.inputAppEnvService.getEnvVar('ALL_MASTERDATA_LISTS_V2');
    return this.http.post<TRESPONSE_masterdataListsV2>(url, request);
  }

  getSilhouetteKeys(request: TREQUEST_silhouetteKeys) {
    const url = this.inputAppEnvService.getEnvVar('SILHOUETEE_KEYS');
    return this.http.post<TRESPONSE_silhouetteKeys>(url, request);
  }

  getCorrectiveReasons(request: TREQUEST_correctiveReasons) {
    const url = this.inputAppEnvService.getEnvVar('CORRECTIVE_REASONS');
    return this.http.post<TRESPONSE_correctiveReasons>(url, request);
  }

  healthCheck() {
    const url = this.inputAppEnvService.getEnvVar('HEALTH_CHECK');
    return this.http.get<any>(url);
  }

  async getSilhoutteImageUrl(subject_key: string, silhoutteName: string, isFrontImage: boolean) {
    const { frontImageId, backImageId } = MasterdataUtil.getFrontAndBackImageIds(silhoutteName);
    const silhoutteFileName = isFrontImage ? frontImageId : backImageId;
    if (this.#capacitor) {
      try {
        const silhoutteDirectoryPathUri = await Filesystem.getUri({
          path: 'Zilingo/Silhouttes',
          directory: Directory.External,
        });
        const url = Capacitor.convertFileSrc(silhoutteDirectoryPathUri.uri + '/' + silhoutteFileName);
        return { url, isDefault: false };
      } catch (error) {
        console.log('[ERROR]: Could not find file', error);
        return { isDefault: true };
      }
    } else {
      return {
        url: MasterdataUtil.getSilhoutteImageUrlForWeb(
          this.inputAppEnvService.getEnvVar('SILHOUTTE_IMAGE'),
          subject_key,
          silhoutteFileName,
        ),
        isDefault: false,
      };
    }
  }

  downloadSilhoutte(silhoutteQueryKey: string) {
    const url = this.inputAppEnvService.getEnvVar('SILHOUTTE_DOWNLOAD');
    return this.http.post(
      url,
      { ids: silhoutteQueryKey },
      {
        responseType: 'blob',
      },
    );
  }

  getServerDefectives(request: TREQUEST_ServerDefectives) {
    const url = this.inputAppEnvService.getEnvVar('GET_SERVER_DEFECTIVES');
    return this.http.post<TRESPONSE_ServerDefectives>(url, request);
  }

  validateUndo(request: TREQUEST_UndoValidation) {
    const url = this.inputAppEnvService.getEnvVar('VALIDATE_UNDO');
    return this.http.post<TRESPONSE_UndoValidation>(url, request);
  }

  backUpData(request: TREQUEST_BACK_UP) {
    const url = this.inputAppEnvService.getEnvVar('BACK_UP');
    return this.http.post<TRESPONSE_BACK_UP>(url, request);
  }

  uploadPhotos(formData: FormData) {
    const url = this.inputAppEnvService.getEnvVar('UPLOAD_DEFECT_IMAGES');
    return this.http.post<TRESPONSE_UPLOAD_PHOTOS>(url, formData);
  }

  getImageUrlsByIds(request: TREQUEST_GET_IMAGE_URLS_BY_IDS) {
    const url = this.inputAppEnvService.getEnvVar('GET_IMAGE_URLS_BY_IDS');
    return this.http.post<TRESPONSE_GET_IMAGE_URLS_BY_IDS>(url, request);
  }

  getRoamingQcTransactions(request: TREQUEST_RoamingQcTransactions) {
    const url = this.inputAppEnvService.getEnvVar('GET_ROAMING_QC_TRANSACIONS');
    return this.http.post<TRESPONSE_RoamingQcTransactions>(url, request);
  }

  getPerPieceTagDetails(request: TREQUEST_GET_PER_PIECE_TAG_DETAILS) {
    const url = this.inputAppEnvService.getEnvVar('GET_PER_PIECE_TAG_DETAILS');
    return this.http.post<TRESPONSE_GET_PER_PIECE_TAG_DETAILS>(url, request);
  }

  getRFIDTagDetails(request: TREQUEST_GET_RFID_TAG_DETAILS) {
    const url = this.inputAppEnvService.getEnvVar('GET_RFID_TAG_DETAILS');
    return this.http.post<TRESPONSE_GET_RFID_TAG_DETAILS>(url, request);
  }

  getPerPieceLineInTransaction(request: TREQUEST_GET_PER_PIECE_LINE_IN_TRANSACTIONS, isStationTypeWipEnd: boolean) {
    const url = isStationTypeWipEnd
      ? this.inputAppEnvService.getEnvVar('GET_PER_PIECE_LINE_IN_TRANSACTIONS_FOR_WIP_END_STATIONS')
      : this.inputAppEnvService.getEnvVar('GET_PER_PIECE_LINE_IN_TRANSACTIONS');
    return this.http.post<TRESPONSE_GET_PER_PIECE_LINE_IN_TRANSACTIONS>(url, request);
  }

  getBulkSilhouetteOperations(payload: TREQUEST_GetBulkSilhouetteOperations) {
    const URL = this.inputAppEnvService.getEnvVar('GET_SILHOUETTE_OPERATIONS');
    return this.http.post<TRESPONSE_GetBulkSilhouetteOperations>(URL, payload, this.httpOptions);
  }

  getIncompleteBundles(payload: TREQUEST_GetIncompleteBundles) {
    const URL = this.inputAppEnvService.getEnvVar('GET_INCOMPLETE_BUNDLES');
    return this.http.post<TRESPONSE_GetIncompleteBundles>(URL, payload, this.httpOptions);
  }

  updateIncompleteBundles(payload: TREQUEST_UpdateIncompleteBundles) {
    const URL = this.inputAppEnvService.getEnvVar('UPDATE_INCOMPLETE_BUNDLES');
    return this.http.post<TRESPONSE_UpdateIncompleteBundles>(URL, payload, this.httpOptions);
  }

  searchTagHistory(payload: any) {
    const URL = this.inputAppEnvService.getEnvVar('GET_TAG_HISTORY');
    return this.http.post(URL, payload, this.httpOptions);
  }

  devicePendingEventsSyncStatusBeforeLogoutAck(payload: TREQUEST_DevicePendingEventsSyncStatusBeforeLogoutAck) {
    const URL = this.inputAppEnvService.getEnvVar('LOGOUT_ACK');
    return this.http.post<TRESPONSE_DevicePendingEventsSyncStatusBeforeLogoutAck>(URL, payload, this.httpOptions);
  }

  getPerPieceTagHistorybyTagId(payload: TREQUEST_GET_PER_PIECE_TAG_HISTORY) {
    const URL = this.inputAppEnvService.getEnvVar('GET_PER_PIECE_TAG_HISTORY');
    return this.http.post<TRESPONSE_GET_PER_PIECE_TAG_HISTORY>(URL, payload);
  }

  getBundleTagHistorybyTagId(payload: TREQUEST_GET_BUNDLE_TAG_HISTORY) {
    const URL = this.inputAppEnvService.getEnvVar('GET_BUNDLE_TAG_HISTORY');
    return this.http.post<TRESPONSE_GET_BUNDLE_TAG_HISTORY>(URL, payload);
  }

  getCutBankSubjects(payload: TREQUEST_GET_CUTBANK_SUBJECTS) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_SUBJECTS');
    return this.http.post<TRESPONSE_GET_CUTBANK_SUBJECTS>(URL, payload);
  }

  checkIfComponentScanEnabled(factoryId: string) {
    const URL = this.inputAppEnvService.getEnvVar('CHECK_IF_COMPONENT_SCAN_ENABLED').replace(':factoryId', factoryId);
    return this.http.post<boolean>(URL, {});
  }

  bulkSaveCutbankTransaction(payload: TREQUEST_BULK_SAVE_CUTBANK_IN | TREQUEST_BULK_SAVE_CUTBANK_OUT) {
    const URL = this.inputAppEnvService.getEnvVar('BULK_SAVE_CUTBANK_IN_TRANSACTIONS');
    return this.http.post<TRESPONSE_BULK_SAVE_CUTBANK_IN>(URL, payload);
  }

  bulkSaveCutbankComponentTagTransaction(payload: TREQUEST_BULK_SAVE_CUTBANK_IN | TREQUEST_BULK_SAVE_CUTBANK_OUT) {
    const URL = this.inputAppEnvService.getEnvVar('BULK_SAVE_COMPONENT_TAG_TRANSACTIONS');
    return this.http.post<TRESPONSE_BULK_SAVE_COMPONENT_TAG_CUTBANK_IN>(URL, payload);
  }

  getCutBankInCuttag(payload: TREQUEST_GET_CUT_TAG) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_CUT_TAG');
    return this.http.post<TRESPONSE_GET_CUT_TAG>(URL, payload);
  }

  getCutbankComponentTag(payload: TREQUEST_GET_COMPONENT_BUNDLE_TAG) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_COMPONENT_TAG');
    return this.http.post<TRESPONSE_GET_COMPONENT_BUNDLE_TAG>(URL, payload);
  }

  validateTagCutbankIn(payload: TREQUEST_TAG_VALIDATION_CUTBANK_IN) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_TAG_VALIDATION');
    return this.http.post<TRESPONSE_TAG_VALIDATION_CUTBANK_IN>(URL, payload);
  }

  validateTagCutbankOut(payload: TREQUEST_TAG_VALIDATION_CUTBANK_OUT) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_TAG_VALIDATION');
    return this.http.post<TRESPONSE_TAG_VALIDATION_CUTBANK_OUT>(URL, payload);
  }

  validateLineInStoreTagStatusCutbankOut(payload: TREQUEST_LINE_IN_STORE_TAG_STATUS_CUTBANK_OUT) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_TAG_VALIDATION');
    return this.http.post<TRESPONSE_LINE_IN_STORE_TAG_STATUS_CUTBANK_OUT>(URL, payload);
  }

  validateComponentBundleTagCutbankIn(payload: TREQUEST_COMPONENT_TAG_VALDATION_CUTBANK_IN) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_COMPONENT_TAG_VALIDATION');
    return this.http.post<TRESPONSE_COMPONENT_TAG_VALIDATION_CUTBANK_IN>(URL, payload);
  }

  validateComponentBundleTagCutbankOut(payload: TREQUEST_COMPONENT_TAG_VALDATION_CUTBANK_OUT) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_COMPONENT_TAG_VALIDATION');
    return this.http.post<TRESPONSE_COMPONENT_TAG_VALIDATION_CUTBANK_OUT>(URL, payload);
  }

  getCutbankTransactionUndoValidation(
    payload: TREQUEST_UNDO_TAG_VALIDATION_CUTBANK_IN | TREQUEST_UNDO_TAG_VALIDATION_CUTBANK_OUT,
  ) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_TRANSACTION_UNDO_VALIDATION');
    return this.http.post<TRESPONSE_UNDO_TAG_VALIDATION>(URL, payload);
  }

  cutbankTransactionUndoWithBctx(payload: TREQUEST_UNDO_TAG_VALIDATION_WITH_BCTX) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_TRANSACTION_UNDO_VALIDATION_WITH_BCTX');
    return this.http.post<TRESPONSE_UNDO_TAG_VALIDATION_WITH_BCTX>(URL, payload);
  }

  deleteCutbankTransaction(payload: TREQUEST_DELETE_TRANSACTION_LOG) {
    const URL = this.inputAppEnvService.getEnvVar('DELETE_CUTBANK_TRANSACTION_LOG');
    return this.http.post<TRESPONSE_DELETE_TRANSACTION_LOG>(URL, payload);
  }

  lineInUndoEvent(payload: TREQUEST_UNDO_TRANSACTION_LINE_IN_EVENT_GENERATE) {
    const URL = this.inputAppEnvService.getEnvVar('UNDO_LINE_IN_EVENT_FROM_CUTBANK_OUT');
    return this.http.post<TRESPONSE_UNDO_TRANSACTION_LINE_IN_EVENT_GENERATE>(URL, payload);
  }

  getCutBankTransactionLog(payload: TREQUEST_CUTBANK_IN_TRANSACTION_LOG | TREQUEST_CUTBANK_OUT_TRANSACTION_LOG) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_TRANSACTION_LOG');
    return this.http.post<TRESPONSE_CUTBANK_IN_TRANSACTION_LOG | TRESPONSE_CUTBANK_OUT_TRANSACTION_LOG>(URL, payload);
  }

  getCutBankInActivityLog(payload: TREQUEST_CUTBANK_IN_ACTIVITY_LOG) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_ACTIVITY_LOG');
    return this.http.post<TRESPONSE_CUTBANK_IN_ACTIVITY_LOG>(URL, payload);
  }

  getCutBankOutActivityLog(payload: TREQUEST_CUTBANK_OUT_ACTIVITY_LOG) {
    const URL = this.inputAppEnvService.getEnvVar('GET_CUTBANK_ACTIVITY_LOG');
    return this.http.post<TRESPONSE_CUTBANK_OUT_ACTIVITY_LOG>(URL, payload);
  }

  getBundleTagDetails(payload: TREQUEST_BUNDLE_TAG_DETAILS) {
    const URL = this.inputAppEnvService.getEnvVar('GET_BUNDLE_TAG_DETAILS');
    return this.http.post<TRESPONSE_BUNDLE_TAG_DETAILS>(URL, payload);
  }

  bulkEditComponentTagQty(payload: TREQUEST_BULK_EDIT_COMPONENT_TAG_QTY) {
    const URL = this.inputAppEnvService.getEnvVar('BULK_EDIT_COMPONENT_TAG_QTY');
    return this.http.post<TRESPONSE_BULK_EDIT_COMPONENT_TAG_QTY>(URL, payload);
  }
  updateRfIdTagsInfo(payload: TREQUEST_VALIDATE_AND_UPDATED_RFID_TAGS_INFO) {
    const url = this.inputAppEnvService.getEnvVar('UPDATE_RFID_TAGS_INFO');
    return this.http.post<TRESPONSE_VALIDATE_AND_UPDATED_RFID_TAGS_INFO>(url, payload);
  }

  updateRfIdTagsInfoV2(payload: TREQUEST_VALIDATE_AND_UPDATED_RFID_TAGS_INFO) {
    const url = this.inputAppEnvService.getEnvVar('UPDATE_RFID_TAGS_INFO_V2');
    return this.http.post<TRESPONSE_VALIDATE_AND_UPDATED_RFID_TAGS_INFO>(url, payload);
  }

  validateRfIdTag(payload: TREQUEST_RFID_TAG_VALIDATION) {
    const url = this.inputAppEnvService.getEnvVar('RFID_TAG_VALIDATION');
    return this.http.post<TRESPONSE_VALIDATE_AND_UPDATED_RFID_TAGS_INFO>(url, payload);
  }
  getBCtxGroupedDetails(payload: TREQUEST_BctxGroupedDetails) {
    const URL = this.inputAppEnvService.getEnvVar('BCTX_GROUP_DETAILS');
    return this.http.post<TRESPONSE_TREQUEST_BctxGroupedDetails>(URL, payload);
  }

  getNewBctxSizeList(payload: TREQUEST_BctxGroupedDetails) {
    const URL = this.inputAppEnvService.getEnvVar('NEW_BCTX_SIZE_LIST');
    return this.http.post<TRESPONSE_NewBctxSizeList>(URL, payload);
  }

  getComponentTagByRfid(payload: TREQUEST_GET_COMPONENT_TAG_BY_RFID): Observable<TRESPONSE_GET_COMPONENT_TAG_BY_RFID> {
    const URL = this.inputAppEnvService.getEnvVar('GET_COMPONENT_TAG_BY_RFID');
    return this.http.post<TRESPONSE_GET_COMPONENT_TAG_BY_RFID>(URL, payload, this.httpOptions);
  }

  getBulkComponentTagWipInfoFromRfid(
    payload: TBulkComponentTagWipInfoFromRfidRequest,
  ): Observable<TBulkComponentTagWipInfoFromRfidResponse> {
    const URL = this.inputAppEnvService.getEnvVar('BULK_COMPONENT_TAG_WIP_INFO_FROM_RFID');
    return this.http.post<TBulkComponentTagWipInfoFromRfidResponse>(URL, payload, this.httpOptions);
  }

  getTagInfoFromRfidTag(payload: TREQUEST_TagInfoByRfidTag): Observable<TRESPONSE_TagInfoByRfidTag> {
    const URL = this.inputAppEnvService.getEnvVar('GET_TAG_INFO_FROM_RFID_TAG');
    return this.http.post<TRESPONSE_TagInfoByRfidTag>(URL, payload, this.httpOptions);
  }
  getProductionReasonList(payload: TREQUEST_FETCH_PRODUCTION_REASON_LIST) {
    const URL = this.inputAppEnvService.getEnvVar('FETCH_PRODUCTION_REASON_LIST');
    return this.http.post<TRESPONSE_FETCH_PRODUCTION_REASON_LIST>(URL, payload, this.httpOptions);
  }

  getSessionBlocksWithReasons(payload: TREQUEST_GET_SESSION_BLOCKS_WITH_REASONS) {
    const URL = this.inputAppEnvService.getEnvVar('GET_SESSION_BLOCKS_WITH_REASONS');
    return this.http.post<TRESPONSE_GET_SESSION_BLOCKS_WITH_REASONS>(URL, payload, this.httpOptions);
  }

  saveSessionBlockReasons(payload: TREQUEST_SAVE_SESSION_BLOCK_REASONS) {
    const URL = this.inputAppEnvService.getEnvVar('SAVE_SESSION_BLOCK_REASONS');
    return this.http.post<TRESPONSE_SAVE_SESSION_BLOCK_REASONS>(URL, payload, this.httpOptions);
  }
}
